export default {
  meta: {
    title: '踩点记录' // 踩点记录
  }
};
